import { render, staticRenderFns } from "./DataAccessLogListItem.vue?vue&type=template&id=71d6ce7c&lang=pug&"
import script from "./DataAccessLogListItem.vue?vue&type=script&lang=js&"
export * from "./DataAccessLogListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports